<p-accordionTab #notifications>
   <!-- ACCORDION TAB -->
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full pt-2 -mb-2">
			<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{'NOTIFICATIONS_EMAIL' | translate }}</span>
			</div>
		</div>
	</ng-template>
   <!-- STANDALONE COMPONENT -->
   <app-notifications-device-list [device]="device" [fromTechnicianDevicesManagement]="false"></app-notifications-device-list>

	<p-divider *ngIf="!disableManeuvers() && !userCurrentlyOwner"></p-divider>

	<!-- STANDALONE COMPONENT -->
	<app-notifications-device-maneuvers *ngIf="!userCurrentlyOwner" [device]="device" [technicianDevicesManagement]="false"></app-notifications-device-maneuvers>
</p-accordionTab>